import React, { useState, useEffect, useCallback } from 'react';
import { withTranslation } from '../ChildrenContext.js';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import DateComponentSettings from './DateComponent_Settings';
import DateComponentCurrencySettings from './DateComponent_CurrencySettings';
import query from '../../helpers/query';
import DataComponentBodyPaymentAccounts from "./DataComponent__BodyPaymentAccounts";

const DataComponentPaymentAccounts = ({
    data: propData,
    headerNames: propHeaderNames,
    multiLevelHeaderNames: propMultiLevelHeaderNames,
    columnData: propColumnData,
    loading: propLoading,
    settings: propSettings,
    settingKey: propSettingKey,
    currencySettings: propCurrencySettings,
    currencySettingKey: propCurrencySettingKey,
    currencySettingData: propCurrencySettingData,
    tableBodyTitle: propTableBodyTitle,
    className: propClassName,
    displayControl: propDisplayControl,
    fields: propFields,
    page: propPage,
    isQuery: propIsQuery,
    alignPagination: propAlignPagination,
    onAction: propOnAction,
    t
}) => {
    const [state, setState] = useState({
        filters: {},
        typeDisplayControl: 'table',
        page: propPage
    });

    useEffect(() => {
        setState(prevState => ({
            ...prevState,
            page: propPage || prevState.page
        }));
    }, [propPage]);

    useEffect(() => {
        !propFields.length && propOnAction && propOnAction({}, 'firstRender');
    }, [propFields.length, propOnAction]);

    const onAction = useCallback((type) => {
        const stateData = {
            ...state.filters
        };

        propOnAction(stateData, type);

        if (propIsQuery) {
            query.replace(stateData);
        }
    }, [state.filters, propOnAction, propIsQuery]);

    const onPageChange = useCallback((page) => {
        setState(prevState => ({
            ...prevState,
            filters: {
                ...prevState.filters,
                page
            }
        }));

        onAction('pageChange');
    }, [onAction]);

    const onFiltersApply = useCallback((stateData, type = 'filtersChange') => {
        setState(prevState => ({
            ...prevState,
            filters: {
                ...stateData
            }
        }));

        onAction(type);
    }, [onAction]);

    const onDisplayControlChange = useCallback((type) => {
        setState(prevState => ({
            ...prevState,
            typeDisplayControl: type
        }));
    }, []);

    const getClassFooter = useCallback(() => {
        return classNames({
            'ibox-footer': true,
            'text-right': propAlignPagination
        });
    }, [propAlignPagination]);

    return (
        <div className="ibox">
            <DateComponentSettings
                settings={propSettings}
                headerNames={propHeaderNames}
                tableBodyTitle={propTableBodyTitle}
                settingKey={propSettingKey}
                loading={propLoading}
                data={propData}
                filters={state.filters}
            />
            <DateComponentCurrencySettings
                settings={propCurrencySettings}
                headerNames={propHeaderNames}
                tableBodyTitle={propTableBodyTitle}
                settingKey={propCurrencySettingKey}
                loading={propLoading}
                data={propCurrencySettingData}
                filters={state.filters}
            />
            <div className="ibox-content">
                <DataComponentBodyPaymentAccounts
                    data={propData}
                    headerNames={propHeaderNames}
                    multiLevelHeaderNames={propMultiLevelHeaderNames}
                    columnData={propColumnData}
                    loading={propLoading}
                    settings={propSettings}
                    settingKey={propSettingKey}
                    displayControl={{
                        ...propDisplayControl,
                        type: state.typeDisplayControl
                    }}
                    filters={state.filters}
                    className={propClassName}
                />
            </div>
        </div>
    );
};

DataComponentPaymentAccounts.propTypes = {
    data: PropTypes.array,
    headerNames: PropTypes.array,
    multiLevelHeaderNames: PropTypes.array,
    columnData: PropTypes.shape({
        header: PropTypes.object,
        body: PropTypes.object
    }),
    loading: PropTypes.bool,
    settings: PropTypes.bool,
    settingKey: PropTypes.string,
    currencySettings: PropTypes.bool,
    currencySettingKey: PropTypes.string,
    currencySettingData: PropTypes.array,
    tableBodyTitle: PropTypes.string,
    className: PropTypes.string,
    displayControl: PropTypes.shape({
        type: PropTypes.string,
        name: PropTypes.string,
        data: PropTypes.array
    }),
    fields: PropTypes.array,
    page: PropTypes.number,
    isQuery: PropTypes.bool,
    alignPagination: PropTypes.bool,
    onAction: PropTypes.func,
    t: PropTypes.object
};

DataComponentPaymentAccounts.defaultProps = {
    data: [],
    headerNames: [],
    multiLevelHeaderNames: [],
    columnData: {
        header: {},
        body: {}
    },
    loading: false,
    settings: false,
    settingKey: '',
    currencySettings: false,
    currencySettingKey: '',
    currencySettingData: [],
    tableBodyTitle: '',
    className: '',
    displayControl: null,
    fields: [],
    page: 1,
    isQuery: false,
    alignPagination: false,
    onAction: () => {}
};

export default withTranslation(DataComponentPaymentAccounts);
